import { DetailOfDispatchToBeAudited } from '../../../../../../core';
import { DataTable } from '../../../data-table.interface';

export const auditProduct: DataTable = {
  hasDisabledInput: (element: DetailOfDispatchToBeAudited): boolean => {
    return element['packCode'] ? true : false
    ;
  },
  columns: [
    {
      title: 'Jaba',
      name: 'containerCode',
      type: 'string',
      editable: false,
      checkAll: false,
      value: (element: DetailOfDispatchToBeAudited) => element.containerCode,
    },
    {
      title: 'Despacho',
      name: 'serialNumber',
      type: 'string',
      class: 'dispatchCode',
      editable: false,
      checkAll: false,
      value: (element: DetailOfDispatchToBeAudited) => element.serialNumber,
    },
    {
      title: 'SKU',
      name: 'skuCode',
      type: 'string',
      editable: false,
      checkAll: false,
      value: (element: DetailOfDispatchToBeAudited) => element.skuCode,
    },
    {
      title: 'Descripción',
      name: 'description',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: DetailOfDispatchToBeAudited) => element.description,
    },
    {
      title: 'Cant. Total',
      name: 'amountAttended',
      type: 'string',
      editable: false,
      align: 'center',
      value: (element: DetailOfDispatchToBeAudited) => element.amountAttended,
    },
    {
      title: 'Cant. A pre-cancelar',
      name: 'amountToDeliver',
      type: 'number',
      editable: true,
      align: 'center',
      placeholderHidden: true,
      value: (element: DetailOfDispatchToBeAudited) => {
        return {
          num: element.precanceledAmount,
          min: 1,
          max: element.precanceledAmount,
        };
      },
    },
    {
      title: 'Motivo de pre-cancelación',
      name: 'reason',
      type: 'newSelect',
      editable: true,
      align: 'center',
      placeholderHidden: true,
      value: (element: any) => {
        return {
          options: element.reason,
          value: element.reasonCancellation,
        };
      },
    },
  ],
};
